/**
 * Builds the swatch caption used under each product image in the PDF.
 *
 * Cabinet products carry both a wood and a finish ("Cherry" + "Slate"), but
 * hardware products have no wood, so Contentful returns null for that field.
 * Joining the two values unconditionally turned that null into a literal
 * "null" prefix in the rendered PDF, so drop the empty parts before joining.
 * This matches the label the generator workflow shows for the same product.
 *
 * @param {{ wood?: string|null, finish?: string|null }} product
 * @returns {string}
 */
export function formatProductLabel(product) {
  const { wood, finish } = product ?? {};
  return [wood, finish].filter(Boolean).join(' ');
}
